import _, { filter } from "lodash";
import React from "react";
import SplitAmount from "./splitAmount";
import { Divider, Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import { getTranslation } from "../../../heplers/translationHelper";

const SplitAmountMapper = ({
	update,
	title,
	array,
	setArray,
	appartmentRent,
	setAppartmentRent,
	setWarranty,
	enableError,
	disableError,
	initialRent,
	disabled,
}) => {
	const handleOnChange = (index, values) => {
		const newArray = [...array];
		if (index >= 0 && index < newArray.length) {
			newArray[index] = values;
		} else {
			newArray.push(values);
		}
		setArray([...newArray]);

		// for sumation of rent ,cost,repair and maintaince in in rent
		var rentArray = newArray.filter(
			(item) => item.type !=1
		);



		setAppartmentRent(
			_.sumBy(rentArray, (item) => parseFloat(item.amount, 10))
		);

		//for summition of warrenty
		var warrantyArray = newArray.filter((item) => item.type === 1);
		setWarranty(_.sumBy(warrantyArray, (item) => parseFloat(item.amount, 10)));

	};

	const removeItem = (index, values) => {
		var newArray = array;
		newArray = array.filter((item, i) => i !== index);
		setArray([...newArray]);

		// for removing  of rent and warranty casts in total rent
		var rentArray = newArray.filter(
			(item) => item.type === 0 || item.type === 2 || item.type === 3
		);
		setAppartmentRent(
			_.sumBy(rentArray, (item) => parseFloat(item.amount, 10))
		);
		console.log("lkjashdkjashdkjada",newArray)

		var warrantyArray = newArray.filter((item) => item.type === 1);
		setWarranty(_.sumBy(warrantyArray, (item) => parseFloat(item.amount, 10)));
	};

	const verticalBar = (
		<Divider
			orientation="vertical"
			variant="middle"
			style={{
				height: "20px",
				backgroundColor: "rgb(251,105,70)",
				margin: 0,
			}}
		/>
	);

	const headerTextStyle = {
		fontSize: "16px",
		fontWeight: 700,
		lineHeight: "19px",
		letterSpacing: "-0.02em",
		textAlign: "left",
		color: "rgb(0,68,103)",
		whiteSpace: "nowrap",
	};

	return (
		<Table
			style={{ width: "100%", borderCollapse: "collapse" }}
			aria-label="borderless-split-amount"
		>
			{/* Header (only for first row) */}

			<TableHead>
				<TableRow>
					<TableCell style={{ borderBottom: "none", paddingBottom: 8, paddingRight: 8, width: 120 }}>
						<Typography style={headerTextStyle}>
							{getTranslation("Indexation", "Indexation", "Indexation")}
						</Typography>
					</TableCell>

					<TableCell style={{ borderBottom: "none", padding: 0, width: 12 }}>
						{verticalBar}
					</TableCell>

					<TableCell style={{ borderBottom: "none", paddingBottom: 8, paddingLeft: 8, paddingRight: 8, width: 180 }}>
						<Typography style={headerTextStyle}>
							{getTranslation("Amount", "Amount", "Amount")}
						</Typography>
					</TableCell>

					<TableCell style={{ borderBottom: "none", padding: 0, width: 12 }}>
						{verticalBar}
					</TableCell>

					<TableCell style={{ borderBottom: "none", paddingBottom: 8, paddingLeft: 8, paddingRight: 8, width: 180 }}>
						<Typography style={headerTextStyle}>
							{getTranslation("Type", "Type", "Type")}
						</Typography>
					</TableCell>

					<TableCell style={{ borderBottom: "none", padding: 0, width: 12 }}>
						{verticalBar}
					</TableCell>

					<TableCell style={{ borderBottom: "none", paddingBottom: 8, paddingLeft: 8 }}>
						<Typography style={headerTextStyle}>
							{getTranslation("Description", "Description", "Description")}
						</Typography>
					</TableCell>

					{/* trailing cell for delete button column (kept empty in header) */}
					<TableCell style={{ borderBottom: "none", paddingBottom: 8, width: 52 }} />
				</TableRow>
			</TableHead>
			<TableBody>
{array.map((item, index) => {
				return (
					<SplitAmount
						update={update}
						title={title}
						item={item}
						count={index}
						onSubmit={handleOnChange}
						appartmentRent={appartmentRent}
						lastItem={array.length}
						deleteItem={removeItem}
						enableError={enableError}
						disableError={disableError}
						initialRent={initialRent}
						disabled={disabled}
					/>
				);
			})}
			</TableBody>
			

		</Table>

	);
};

export default SplitAmountMapper;
